import { ButtonProps } from '@nexelem/deprecated-theme';
import { useIsJumbo } from '@nexelem/utils';
import { Avatar, Button } from '@nexelem/components';
import clsx from 'clsx';

export type User = {
  firstName: string;
  lastName: string;
};

export interface ProfileButtonProps extends Omit<ButtonProps, 'component'> {
  src?: string;
  user?: User;
  avatarOnly?: boolean;
}

export const ProfileButton = ({ src: _src, user, avatarOnly, ...props }: ProfileButtonProps) => {
  const isJumbo = useIsJumbo();
  const { firstName, lastName } = user ?? {};

  return (
    <Button
      {...props}
      className={clsx('rounded-full pl-1', isJumbo ? 'pl-2' : 'pl-1', avatarOnly && 'p-1')}
      size={isJumbo ? 'jumbo' : 'medium'}
      StartIcon={<Avatar firstName={firstName} lastName={lastName} size={isJumbo ? 'large' : 'medium'} />}
      variant="text"
    >
      {!avatarOnly && `${firstName} ${lastName}`}
    </Button>
  );
};
